(function() {
  'use strict';

  // ========================
  // QUANTITY CONTROLS (always works, no dependencies)
  // ========================
  var qtyInput = document.querySelector('[data-qty-input]');
  var qtyMinus = document.querySelector('[data-qty-minus]');
  var qtyPlus = document.querySelector('[data-qty-plus]');

  if (qtyMinus && qtyInput) {
    qtyMinus.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var val = parseInt(qtyInput.value) - 1;
      if (val >= 1) qtyInput.value = val;
    });
  }
  if (qtyPlus && qtyInput) {
    qtyPlus.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var next = parseInt(qtyInput.value) + 1;
      var max = qtyInput.max ? parseInt(qtyInput.max) : Infinity;
      if (next <= max) qtyInput.value = next;
    });
  }

  // Clamp quantity while typing (input) and on blur (change)
  function clampQty() {
    var val = parseInt(qtyInput.value);
    if (isNaN(val) || val < 1) { qtyInput.value = 1; return; }
    var max = qtyInput.max ? parseInt(qtyInput.max) : Infinity;
    if (val > max) qtyInput.value = max;
  }
  if (qtyInput) {
    qtyInput.addEventListener('input', clampQty);
    qtyInput.addEventListener('change', clampQty);
  }

  // Apply inventory cap on initial page load
  (function() {
    var sel = document.querySelector('[data-variant-select]');
    if (sel && qtyInput) {
      var opt = sel.options[sel.selectedIndex];
      if (opt) {
        var inv = parseInt(opt.dataset.inventory) || 0;
        var pol = opt.dataset.inventoryPolicy;
        if (pol !== 'continue' && inv > 0) {
          qtyInput.max = inv;
        }
      }
    }
  })();

  // ========================
  // VARIANT SELECTION (DOM-based, no JSON dependency)
  // ========================
  var variantSelect = document.querySelector('[data-variant-select]');
  var priceEl = document.querySelector('[data-product-price]');
  var addBtn = document.querySelector('[data-add-to-cart]');
  var addBtnText = document.querySelector('[data-add-to-cart-text]');
  var buyNowBtn = document.querySelector('[data-buy-now]');
  var optionGroups = document.querySelectorAll('[data-option-index]');

  if (!variantSelect) return;

  // Build current selections from active buttons
  function getSelectedOptions() {
    var selections = {};
    document.querySelectorAll('.product-form__variant-btn.is-active').forEach(function(btn) {
      selections[btn.dataset.optionIndex] = btn.dataset.optionValue.trim();
    });
    return selections;
  }

  // Find matching variant from the <select> element by matching option text
  function findMatchingVariant(selections) {
    var options = variantSelect.querySelectorAll('option');
    var selValues = Object.values(selections);

    for (var i = 0; i < options.length; i++) {
      var optionText = options[i].textContent.trim();
      // The option text format is "Value1 / Value2 — Rs. XX.XX" or just "Value — Rs. XX.XX"
      var titlePart = optionText.split('—')[0].trim();
      var titleValues = titlePart.split('/').map(function(s) { return s.trim(); });

      var allMatch = selValues.every(function(sel) {
        return titleValues.some(function(tv) { return tv === sel; });
      });

      if (allMatch) return options[i];
    }
    return null;
  }

  function formatMoney(cents) {
    if (!cents && cents !== 0) return '';
    return 'Rs. ' + (parseInt(cents) / 100).toFixed(2);
  }

  function updateFromSelection() {
    var selections = getSelectedOptions();
    var matchedOption = findMatchingVariant(selections);

    if (!matchedOption) return;

    // Update the hidden select
    variantSelect.value = matchedOption.value;

    // Read price data from the option's data attributes
    var price = matchedOption.dataset.price;
    var comparePrice = matchedOption.dataset.comparePrice;
    var available = matchedOption.dataset.available === 'true';

    // Update price display
    if (priceEl && price) {
      var html = '';
      if (comparePrice && parseInt(comparePrice) > parseInt(price)) {
        html = '<span class="price"><span class="price__compare">' + formatMoney(comparePrice) + '</span> <span class="price__sale">' + formatMoney(price) + '</span></span>';
      } else {
        html = '<span class="price"><span class="price__regular">' + formatMoney(price) + '</span></span>';
      }
      priceEl.innerHTML = html;
    }

    // Update Add to Cart button
    if (addBtn && addBtnText) {
      addBtn.disabled = !available;
      addBtnText.textContent = available ? 'Add to Cart' : 'Sold Out';
    }

    // Update Buy Now button
    if (buyNowBtn) {
      buyNowBtn.dataset.variantId = matchedOption.value;
      buyNowBtn.style.display = available ? '' : 'none';
    }

    // Update stock status text
    var stockEl = document.querySelector('[data-stock-status]');
    if (stockEl) {
      var inv = parseInt(matchedOption.dataset.inventory) || 0;
      var pol = matchedOption.dataset.inventoryPolicy;
      if (!available) {
        stockEl.textContent = 'Out of stock';
        stockEl.className = 'product-form__stock is-out';
      } else if (pol === 'continue' || inv > 5) {
        stockEl.textContent = 'In stock';
        stockEl.className = 'product-form__stock';
      } else if (inv > 0) {
        stockEl.textContent = 'Only ' + inv + ' left — order soon!';
        stockEl.className = 'product-form__stock is-low';
      } else {
        stockEl.textContent = 'In stock';
        stockEl.className = 'product-form__stock';
      }
    }

    // Update quantity max based on inventory
    var inventory = parseInt(matchedOption.dataset.inventory) || 0;
    var policy = matchedOption.dataset.inventoryPolicy;
    // If policy is 'continue', allow overselling (no cap)
    if (policy !== 'continue' && inventory > 0 && qtyInput) {
      qtyInput.max = inventory;
      if (parseInt(qtyInput.value) > inventory) qtyInput.value = inventory;
    } else if (qtyInput) {
      qtyInput.removeAttribute('max');
    }

    // Update URL
    if (history.replaceState) {
      history.replaceState(null, '', window.location.pathname + '?variant=' + matchedOption.value);
    }
  }

  // Variant button clicks
  document.querySelectorAll('.product-form__variant-btn').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      // Toggle active in same group
      var siblings = btn.parentElement.querySelectorAll('.product-form__variant-btn');
      siblings.forEach(function(s) { s.classList.remove('is-active'); });
      btn.classList.add('is-active');

      // Reset quantity to 1 on variant change
      if (qtyInput) qtyInput.value = 1;

      updateFromSelection();
    });
  });

  // ========================
  // BUY IT NOW
  // ========================
  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', function() {
      var variantId = buyNowBtn.dataset.variantId;
      var qty = qtyInput ? qtyInput.value : 1;

      buyNowBtn.disabled = true;
      buyNowBtn.textContent = 'Processing...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: parseInt(qty) })
      })
      .then(function() { window.location.href = '/checkout'; })
      .catch(function() {
        buyNowBtn.disabled = false;
        buyNowBtn.textContent = 'Buy it now';
      });
    });
  }

  // ========================
  // LIVE AVAILABILITY REFRESH
  // ========================
  // Shopify's storefront product JSON does not include inventory_quantity —
  // only the Liquid-baked data-inventory values are accurate for counts.
  // This fetch only updates data-available so sold-out state stays current
  // without wiping the inventory cap from the Liquid render.
  (function() {
    if (typeof productData === 'undefined' || !productData.handle || !variantSelect) return;
    fetch('/products/' + productData.handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(live) {
        var avMap = {};
        live.variants.forEach(function(v) { avMap[v.id] = v.available; });
        var options = variantSelect.querySelectorAll('option');
        var updated = false;
        options.forEach(function(opt) {
          if (!(parseInt(opt.value) in avMap)) return;
          opt.dataset.available = avMap[parseInt(opt.value)] ? 'true' : 'false';
          updated = true;
        });
        if (updated) updateFromSelection();
      })
      .catch(function() {});
  })();

  // ========================
  // TRACK RECENTLY VIEWED
  // ========================
  try {
    if (typeof productData !== 'undefined') {
      var viewed = JSON.parse(localStorage.getItem('att_recently_viewed') || '[]');
      var current = {
        id: productData.id,
        title: productData.title,
        url: window.location.pathname,
        image: productData.featured_image,
        price: productData.price,
        compare_at_price: productData.compare_at_price
      };
      viewed = viewed.filter(function(p) { return p.id !== current.id; });
      viewed.unshift(current);
      viewed = viewed.slice(0, 5);
      localStorage.setItem('att_recently_viewed', JSON.stringify(viewed));
    }
  } catch(e) {}
})();
